import { createVuetify } from "vuetify";
import "vuetify/styles";

const light = {
  dark: false,
  colors: {
    primary: "#F89C23",
    "on-primary": "#FFFFFF",
    primaryLight: "#FFC069",
    primaryDark: "#E08217",
    secondary: "#2EC4B6",
    "on-secondary": "#FFFFFF",
    accent: "#21356A",
    "on-accent": "#FFFFFF",
    warning: "#f9a825"
  }
};

const vuetify = createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light,
      dark: Object.assign({}, light, { dark: true })
    }
  },
  defaults: {
    VTextField: {
      color: "primary"
    },
    VTextarea: {
      color: "primary"
    },
    VCombobox: {
      color: "primary"
    },
    VRadioGroup: {
      color: "primary"
    },
    VSlider: {
      color: "primary",
      density: "compact"
    },
    VRangeSlider: {
      color: "primary",
      density: "compact"
    }
  }
});

export default vuetify;